import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<span ...attributes class=\"fly-svg-icon {{this.duotoneClasses}} {{this.sizeClass}}\">\n  {{svg-jar @icon class=this.svgClassNames role=\"img\" aria-labelledby=@icon}}\n</span>", {
  moduleName: "@customerio/fly-components/components/fly-icon.hbs"
});